import { T, F, modules, type ModuleKey } from './tokens';
import { useNavigate } from 'react-router-dom';

interface ModuleHeaderProps {
  module: ModuleKey;
  subtitle?: string;
  onBack?: () => void;
}

export function ModuleHeader({ module, subtitle, onBack }: ModuleHeaderProps) {
  const m = modules[module];
  const navigate = useNavigate();

  const handleBack = onBack || (() => navigate(-1));

  return (
    <div style={{
      padding: '16px 20px 12px',
      background: `linear-gradient(180deg, ${m.soft} 0%, transparent 100%)`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          onClick={handleBack}
          style={{
            background: 'none', border: 'none', fontSize: 20,
            cursor: 'pointer', padding: 0, color: T.text,
          }}
        >
          &#8592;
        </button>
        <div style={{
          width: 36, height: 36, borderRadius: T.radius.md,
          background: m.soft, border: `1.5px solid ${m.color}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: F.mono, fontSize: 11, fontWeight: 700,
          color: m.color, letterSpacing: 0.5,
        }}>
          {m.abbr}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: F.body, fontSize: 18, fontWeight: 700, color: T.text }}>
            {m.name}
          </div>
          {subtitle && (
            <div style={{ fontSize: 11, color: T.textMuted, fontFamily: F.body }}>
              {subtitle}
            </div>
          )}
        </div>
        <div style={{
          width: 32, height: 32, borderRadius: T.radius.sm,
          background: T.bgInput,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 11, color: T.textMuted, fontFamily: F.mono, fontWeight: 600,
        }}>
          &middot;&middot;&middot;
        </div>
      </div>
    </div>
  );
}
